import { css } from '@inter-ikea-kompis/web-component';
import { ProductComplianceTechnicalHeadingTypeEnum } from '@inter-ikea-kompis/enums';
import { Text } from '@ingka/common-styles-webc';
import PriceModuleLayoutTypeEnum from '../../enums/PriceModuleLayoutTypeEnum.js';
import PriceModuleProductLinkEnum from '../../enums/PriceModuleProductLinkEnum.js';
export default class PriceModuleStyle {
    /**
     * Returns style.
     *
     * @param options Options.
     * @param options.theme Theme.
     * @param options.isBti Is breath taking item.
     * @param options.layout Layout.
     * @param options.productLink ...
     * @param options.disableLinks ...
     * @param options.complianceType ...
     * @param options.underline ...
     * @param options.loyaltyProgramEqualFontSize ...
     * @param options.withoutPrice ...
     * @param options.disableFocusStyle ...
     * @param options.isComponentListTotalPriceChild ...
     * @returns Css.
     */
    static getStyle(options) {
        const { theme: { color, spacing }, isComponentListTotalPriceChild, loyaltyProgramEqualFontSize, productLink, disableLinks, layout, underline, isBti } = options;
        return css `
			${Text.CSS}
			:host {
				display: flex;
				flex-direction: column;
				align-items: flex-start;
			}

			p {
				margin: 0;
			}

			button {
				background: none;
				color: inherit;
				border: none;
				padding: 0;
				font: inherit;
				cursor: pointer;
				outline: inherit;
				text-decoration: ${underline ? 'underline' : 'none'};
			}

			.productName button {
				text-align: left;
			}

			a {
				color: inherit;
				outline: 0;
				text-decoration: ${underline ? 'underline' : 'none'};
			}

			.actionElement {
				position: relative;
			}

			.actionElement:after {
				content: '';
				position: absolute;
				left: 0;
				width: 100%;
				height: 100%;
				min-width: ${24 / 16}rem;
				min-height: ${24 / 16}rem;
			}

			.productContent:hover .actionElement {
				text-decoration: underline;
			}

			.productName,
			.regularPrice,
			.price,
			.secondaryPrice {
				color: ${color.neutral.grey900};
			}

			.productName {
				margin: 0;
			}

			.fromPriceProductContent {
				overflow-wrap: anywhere;
			}

			.productContent {
				display: flex;
				flex-direction: column;
				text-decoration: none;
				cursor: ${productLink !== PriceModuleProductLinkEnum.disabled && !disableLinks
            ? 'pointer'
            : 'auto'};
				overflow-wrap: anywhere;
			}

			.productDescription {
				color: ${color.text.default};
			}

			.regularPrice {
				margin-top: ${this.getPriceMargins(options)}rem;
			}

			.visuallyHidden:not(:focus):not(:active) {
				clip: rect(0 0 0 0);
				clip-path: inset(50%);
				height: ${1 / 16}rem;
				overflow: hidden;
				position: absolute;
				white-space: nowrap;
				width: ${1 / 16}rem;
			}

			.price,
			.secondaryPrice {
				display: flex;
				${this.getEnergyAlignment(options) ?? ''}
				${this.getPriceFlexDirection(options) ?? ''};
				margin-top: ${this.getPriceMargins(options)}rem;
				margin-bottom: ${isBti ? this.getBtiMargins(options) : this.getPriceMargins(options)}rem;
			}

			.secondaryPrice {
				margin-top: 0;
			}

			.priceContainer {
				font-weight: bold;
				display: flex;
				flex-wrap: wrap;
			}

			.divider {
				flex-shrink: 0;
				width: ${(layout === PriceModuleLayoutTypeEnum.emphasized
            ? spacing.space50
            : spacing.space25) / 16}rem;
			}

			.priceText,
			.priceExclTax {
				display: inline-flex;
			}

			.lowestPreviousSalesPrice {
				display: inline-block;
			}

			.priceUnitEmphasized,
			.priceContainer span {
				display: flex;
				line-height: ${this.getPriceUnitLineHeight(layout)};
				align-self: ${this.getPriceUnitAlignment(layout)};
				font-size: ${this.getPriceUnitFontSize(layout)};
			}

			.priceText {
				flex-direction: column;
				color: ${color.neutral.grey700};
			}

			kompis-text:last-child .priceContainer:not(:only-child) {
				padding-bottom: 0;
			}

			skapa-commercial-message {
				margin-bottom: ${(loyaltyProgramEqualFontSize || isComponentListTotalPriceChild
            ? 0
            : spacing.space25) / 16}rem;
				font-size: ${14 / 16}rem;
			}

			kompis-repairability-index {
				margin-top: ${spacing.space50 / 16}rem;
			}

			.regularPriceTextContainer {
				display: flex;
				flex-wrap: wrap;
				flex-direction: row;
				justify-content: ${layout === PriceModuleLayoutTypeEnum.listPrice ? 'flex-end' : 'initial'};
			}

			.regularPricePrefixText {
				color: ${color.neutral.grey700};
			}

			${this.getBreathTakingItem(options) ?? ''}
			${this.getEnergyMargins(options) ?? ''}
			${this.getWithoutPriceStyling(options) ?? ''}
			${this.getOutlineStyle(options) ?? ''}

			.priceText .price:last-of-type {
				margin-top: 0rem;
			}
		`;
    }
    /**
     * Returns price unit line-height.
     *
     * @param layout ...
     * @returns Price unit line-height.
     */
    static getPriceUnitLineHeight(layout) {
        switch (layout) {
            case PriceModuleLayoutTypeEnum.subtle:
            case PriceModuleLayoutTypeEnum.rowPrice:
                return 1;
            case PriceModuleLayoutTypeEnum.default:
            case PriceModuleLayoutTypeEnum.emphasized:
            case PriceModuleLayoutTypeEnum.listPrice:
                return 1.15;
        }
    }
    /**
     * Returns price unit alignment.
     *
     * @param layout ...
     * @returns Price unit alignment.
     */
    static getPriceUnitAlignment(layout) {
        switch (layout) {
            case PriceModuleLayoutTypeEnum.subtle:
            case PriceModuleLayoutTypeEnum.rowPrice:
                return 'auto';
            case PriceModuleLayoutTypeEnum.default:
            case PriceModuleLayoutTypeEnum.emphasized:
            case PriceModuleLayoutTypeEnum.listPrice:
                return 'flex-end';
        }
    }
    /**
     * Returns price unit font size.
     *
     * @param layout ...
     * @returns Price unit font size.
     */
    static getPriceUnitFontSize(layout) {
        switch (layout) {
            case PriceModuleLayoutTypeEnum.subtle:
            case PriceModuleLayoutTypeEnum.rowPrice:
                return '100%';
            case PriceModuleLayoutTypeEnum.default:
            case PriceModuleLayoutTypeEnum.emphasized:
            case PriceModuleLayoutTypeEnum.listPrice:
                return '60%';
        }
    }
    /**
     * Returns bti style.
     *
     * @param options Options.
     * @param options.theme Theme.
     * @param options.isBti Is breath taking item.
     * @param options.layout Layout.
     * @returns Css.
     */
    static getBreathTakingItem(options) {
        if (!options.isBti) {
            return null;
        }
        const { color } = options.theme;
        const btiSize = this.getBreathTakingItemSize(options.layout);
        const boxShadowSize = Math.ceil(btiSize * 0.125);
        return css `
			.priceContainer {
				background-color: ${color.commercialMessage.btiYellow};
				box-shadow: ${boxShadowSize / 16}rem ${boxShadowSize / 16}rem
					${color.commercialMessage.btiRed};
				padding: ${Math.ceil(btiSize * 0.2) / 16}rem ${Math.ceil(btiSize * 0.3) / 16}rem;
				margin-bottom: ${this.getBtiMargins(options)}rem;
			}

			kompis-energy-efficiency-class {
				margin-bottom: ${options.theme.spacing.space50 / 16}rem;
			}

			.price,
			.secondaryPrice .priceContainer {
				margin-bottom: 0;
			}
		`;
    }
    static getPriceMargins(options) {
        const { spacing } = options.theme;
        switch (options.layout) {
            case PriceModuleLayoutTypeEnum.subtle:
            case PriceModuleLayoutTypeEnum.rowPrice:
            case PriceModuleLayoutTypeEnum.listPrice:
                return spacing.space25 / 16;
            case PriceModuleLayoutTypeEnum.default:
            case PriceModuleLayoutTypeEnum.emphasized:
                return spacing.space50 / 16;
        }
    }
    static getBtiMargins(options) {
        const { spacing } = options.theme;
        switch (options.layout) {
            case PriceModuleLayoutTypeEnum.subtle:
            case PriceModuleLayoutTypeEnum.rowPrice:
                return spacing.space50 / 16;
            case PriceModuleLayoutTypeEnum.default:
            case PriceModuleLayoutTypeEnum.listPrice:
                return spacing.space75 / 16;
            case PriceModuleLayoutTypeEnum.emphasized:
                return spacing.space100 / 16;
        }
    }
    /**
     * Returns bti size.
     *
     * @returns Bti size.
     */
    static getBreathTakingItemSize(layout) {
        switch (layout) {
            case PriceModuleLayoutTypeEnum.subtle:
                return 12;
            case PriceModuleLayoutTypeEnum.default:
                return 28;
            case PriceModuleLayoutTypeEnum.emphasized:
                return 45;
            case PriceModuleLayoutTypeEnum.rowPrice:
                return 14;
            case PriceModuleLayoutTypeEnum.listPrice:
                return 25;
        }
    }
    /**
     * Returns energy class margin.
     *
     * @param options Options.
     * @param options.theme Theme.
     * @param options.layout Layout.
     * @returns Energy class margin.
     */
    static getEnergyClassMargin(options) {
        const { spacing } = options.theme;
        switch (options.layout) {
            case PriceModuleLayoutTypeEnum.subtle:
            case PriceModuleLayoutTypeEnum.rowPrice:
                return spacing.space25 / 16;
            case PriceModuleLayoutTypeEnum.default:
            case PriceModuleLayoutTypeEnum.listPrice:
                return spacing.space50 / 16;
            case PriceModuleLayoutTypeEnum.emphasized:
                return spacing.space75 / 16;
        }
    }
    /**
     * Returns compliance icon alignment.
     *
     * @param options ...
     * @param options.complianceType ...
     */
    static getEnergyAlignment(options) {
        if (!options.complianceType) {
            return null;
        }
        switch (options.complianceType) {
            case ProductComplianceTechnicalHeadingTypeEnum.energyEfficiencyClass:
                return 'align-items: center; flex-wrap: wrap;';
            case ProductComplianceTechnicalHeadingTypeEnum.unifiedWaterLabel:
            case ProductComplianceTechnicalHeadingTypeEnum.hyperlink:
                return 'align-items: stretch;';
        }
        return null;
    }
    static getPriceFlexDirection(options) {
        const { complianceType, layout } = options;
        const isListPriceLayout = layout === PriceModuleLayoutTypeEnum.listPrice;
        if (!complianceType && !isListPriceLayout) {
            return null;
        }
        if (isListPriceLayout) {
            return 'flex-direction: row-reverse';
        }
        switch (complianceType) {
            case ProductComplianceTechnicalHeadingTypeEnum.energyEfficiencyClass:
                return 'flex-direction: row';
            case ProductComplianceTechnicalHeadingTypeEnum.hyperlink:
            case ProductComplianceTechnicalHeadingTypeEnum.unifiedWaterLabel:
                return 'flex-direction: column';
        }
        return null;
    }
    /**
     * Returns margin for energy compliance icon based on its type (EU/US).
     *
     * @param options ...
     * @param options.theme ...
     * @param options.isBti ...
     * @param options.layout ...
     * @param options.complianceType ...
     */
    static getEnergyMargins(options) {
        switch (options.complianceType) {
            case ProductComplianceTechnicalHeadingTypeEnum.energyEfficiencyClass: {
                const energyClassMargin = this.getEnergyClassMargin(options);
                return css `
					.price {
						${options.isBti
                    ? css `
									column-gap: ${this.getBtiMargins(options)}rem;
								`
                    : css `
									column-gap: ${energyClassMargin}rem;
									row-gap: ${energyClassMargin}rem;
								`}
					}
				`;
            }
            case ProductComplianceTechnicalHeadingTypeEnum.hyperlink:
                return css `
					kompis-energy-efficiency-class {
						margin-top: ${options.theme.spacing.space50 / 16}rem;
						width: ${options.theme.spacing.space400 / 16}rem;
					}
				`;
            case ProductComplianceTechnicalHeadingTypeEnum.unifiedWaterLabel:
                return css `
					kompis-water-efficiency-class {
						margin-top: ${options.theme.spacing.space50 / 16}rem;
					}
				`;
        }
        return null;
    }
    /**
     * Return styling for when there is no price.
     *
     * @param options ...
     * @param options.withoutPrice ...
     * @param options.theme ...
     */
    static getWithoutPriceStyling(options) {
        if (!options.withoutPrice) {
            return null;
        }
        return css `
			kompis-water-efficiency-class,
			kompis-energy-efficiency-class {
				margin-top: ${options.theme.spacing.space50 / 16}rem;
			}

			.priceText {
				margin-top: ${options.theme.spacing.space25 / 16}rem;
			}
		`;
    }
    static getOutlineStyle(options) {
        if (options.disableFocusStyle) {
            return null;
        }
        const { focusOutline, color, motion } = options.theme;
        return css `
			.productContent:focus-within {
				z-index: 1;
				box-shadow: 0 0 0 ${focusOutline.offset / 16}rem ${color.border.inverse};
				outline: ${focusOutline.width / 16}rem solid ${focusOutline.color};
				outline-offset: ${focusOutline.offset / 16}rem;
				transition:
					outline ${motion.duration.medium} ease-out,
					box-shadow ${motion.duration.medium} ease-out;
			}
		`;
    }
}
//# sourceMappingURL=PriceModuleStyle.js.map